<template>
  <ProductConfigurator />
</template>

<script>
import ProductConfigurator from "components/ProductConfigurator";

export default {
  name: 'App',
  components: {ProductConfigurator},
}
</script>

<style>
.basket .qty-wrapper .configurepos{
  display: none;
}

.js-start-configuration.start-configuration {
  display: none;
}
</style>
